"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const KeyCodes_1 = __importDefault(require("@opsbase/lib-general/KeyCodes"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const AddCommentIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AddCommentIcon"));
const AttachmentIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AttachmentIcon"));
const ImageEditorDialog_1 = __importDefault(require("@opsbase/web-image/ImageEditorDialog"));
const ImageUploadButton_1 = __importDefault(require("@opsbase/web-image/ImageUploadButton"));
const ImageViewer_1 = __importDefault(require("@opsbase/web-image/ImageViewer"));
const useManyImages_1 = __importDefault(require("@opsbase/web-image/useManyImages"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    addComment: {
    // borderTop: `1px solid ${Palette.InputBorderGrey.main}`,
    },
    saveButton: {
        maxWidth: 24,
        width: 24,
        minWidth: 24,
        height: 24,
        borderRadius: 12,
        padding: 0,
    },
});
const PhotoTextInput = ({ updateTextFieldRef, editable, placeholderText, isSaving, text, onTextChange, images: propsImages, onSave, onImagesChange, multiline, InputProps, hideSubmitButton, }) => {
    var _a, _b;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleSave = (0, react_1.useCallback)(() => {
        if (!isSaving)
            onSave === null || onSave === void 0 ? void 0 : onSave();
    }, [isSaving, onSave]);
    const handleKeyUp = (0, react_1.useCallback)(e => {
        if (e.keyCode === KeyCodes_1.default.ENTER) {
            handleSave();
        }
    }, [handleSave]);
    const handleImagesChange = (0, react_1.useCallback)((newImages) => {
        onImagesChange === null || onImagesChange === void 0 ? void 0 : onImagesChange(newImages);
    }, [onImagesChange]);
    const { deleteImage, addImage, handleAccept, handleCancel, hideEditor, resolvedImages, resetImages, } = (0, useManyImages_1.default)({
        images: propsImages,
        onImagesChange: handleImagesChange,
    });
    const len = ((_a = resolvedImages === null || resolvedImages === void 0 ? void 0 : resolvedImages.length) !== null && _a !== void 0 ? _a : 0) - 1;
    const prevPropsImages = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        // IHS-1428: restricting this to run only when props images are updated
        // and retaining the old condition on zero length. But, that condition may
        // no longer be needed
        if (prevPropsImages.current !== propsImages) {
            if (len === -1 && (propsImages === null || propsImages === void 0 ? void 0 : propsImages.length))
                resetImages(propsImages);
            prevPropsImages.current = propsImages;
        }
    }, [len, propsImages, resetImages]);
    const needToClearoutPhotos = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (isSaving)
            needToClearoutPhotos.current = true;
        if (needToClearoutPhotos.current && !isSaving) {
            resetImages([]);
            needToClearoutPhotos.current = false;
        }
    }, [isSaving, resetImages]);
    return (react_1.default.createElement(Pane_1.default, { padding: 2, classes: { root: myCss.addComment + ' PhotoTextInput' } },
        !hideEditor ? (react_1.default.createElement(ImageEditorDialog_1.default, { dataUrl: (_b = resolvedImages[len]) === null || _b === void 0 ? void 0 : _b.imageData, onCancel: handleCancel, onAccept: handleAccept })) : null,
        (resolvedImages === null || resolvedImages === void 0 ? void 0 : resolvedImages.length) ? (react_1.default.createElement(core_1.Grid, { container: true, spacing: 0 },
            react_1.default.createElement(ImageViewer_1.default, { resolvedImages: resolvedImages, size: 50, editable: true, onDeleteImage: deleteImage }))) : null,
        react_1.default.createElement(TextField_1.default, { noBorder: true, inputRef: updateTextFieldRef, disabled: !editable, fullWidth: true, placeholder: placeholderText, value: text, onKeyUp: handleKeyUp, onChange: onTextChange, multiline: multiline, InputProps: Object.assign({ style: {
                    borderRadius: 0,
                    borderBottomWidth: 0,
                }, endAdornment: editable ? (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                    !hideSubmitButton ? (react_1.default.createElement(Button_1.default, { icon: !isSaving && (react_1.default.createElement(AddCommentIcon_1.default, null, lib_i18n_1.default.t('post'))), onClick: handleSave, style: { marginBottom: 8 }, classes: { root: myCss.saveButton } }, isSaving && (react_1.default.createElement(Spinner_1.default, { size: 16, inline: true, busy: true, color: lib_palette_1.default.White })))) : null,
                    react_1.default.createElement(ImageUploadButton_1.default, { onUpload: addImage, uploadButtonStyle: {
                            padding: 2,
                            borderRadius: 12,
                            minWidth: 0,
                            minHeight: 0,
                            marginLeft: 8,
                            marginBottom: 8,
                        } },
                        react_1.default.createElement(AttachmentIcon_1.default, { htmlColor: lib_palette_1.default.White.main, size: 20 }, lib_i18n_1.default.t('post'))))) : null }, InputProps) })));
};
exports.default = PhotoTextInput;
